import React, { useState, useContext } from 'react';
import { useAtom } from 'jotai';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import { isAuthAtom, dataUserAtom, setDataUserAtom } from '../Services/store/atoms';
import config from '../Config';
import DarkModeContext from '../Components/DarkModeContext';
import Header from '../Layouts/Header';
import Container from '../Layouts/Container';
import { FaUserFriends, FaCamera, FaSpinner } from 'react-icons/fa';
import { LuChevronRight } from 'react-icons/lu';

function ChooseRole() {
    const history = useHistory();
    const [isAuth] = useAtom(isAuthAtom);
    const [dataUser] = useAtom(dataUserAtom);
    const [, setDataUser] = useAtom(setDataUserAtom);
    const { darkMode } = useContext(DarkModeContext);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);

    if (!isAuth) {
        history.push('/');
        return null;
    }
    if (dataUser.role) {
        history.push('/' + dataUser.role);
        return null;
    }

    const chooseRole = (role) => {
        setIsLoading(true);
        setErrorMsg(null);
        axios.post(`${config.REACT_APP_BASE_URL}/api/v1/auth/choose-role`, { role })
            .then(function (response) {
                const updatedUser = { ...dataUser, ...response.data.user };
                setDataUser(updatedUser);
                if (role === 'client') {
                    history.push('/client');
                } else if (!updatedUser.name || !updatedUser.phone) {
                    history.push('/model/complete-registration');
                } else {
                    history.push('/model');
                }
            })
            .catch(function (error) {
                setIsLoading(false);
                setErrorMsg(error.response?.data?.message || 'No se pudo guardar tu elección.');
            });
    };

    // Cada opción es una fila de lista agrupada con chevron, como en Ajustes de iOS.
    const option = (role, Icon, title, subtitle) => (
        <button
            onClick={() => chooseRole(role)}
            disabled={isLoading}
            className="ap-row w-full text-left py-3 hover:bg-[var(--ap-fill)] disabled:opacity-50 disabled:cursor-not-allowed"
        >
            <span className="flex items-center justify-center w-9 h-9 rounded-[9px] text-white text-lg shrink-0" style={{ background: 'var(--ap-tint)' }}>
                <Icon />
            </span>
            <span className="flex-1 min-w-0 pl-1">
                <span className="ap-body block">{title}</span>
                <span className="ap-footnote block">{subtitle}</span>
            </span>
            <LuChevronRight className="shrink-0 text-xl" style={{ color: 'var(--ap-label-3)' }} />
        </button>
    );

    return (
        <div className={`ap-screen relative min-h-dvh m-0 p-0 flex flex-col ${darkMode ? 'dark' : ''}`}>
            <Header />
            <Container>
                <div className="flex justify-center px-4 pt-14 pb-10">
                    <div className="w-full max-w-[420px]">
                        <h1 className="ap-large-title text-center">
                            ¿Cómo quieres usar la plataforma?
                        </h1>
                        <p className="ap-subhead text-center mt-3">
                            Elige una opción para continuar. No podrás cambiarla después.
                        </p>
                        <div className="ap-card ap-rows-icon-lg overflow-hidden mt-8">
                            {option('client', FaUserFriends, 'Soy cliente', 'Quiero ver y comprar contenido')}
                            {option('model', FaCamera, 'Soy modelo', 'Quiero subir y vender contenido')}
                        </div>
                        {isLoading && <FaSpinner className="animate-spin mx-auto mt-6" style={{ color: 'var(--ap-tint)' }} />}
                        {errorMsg && <p className="ap-error text-center mt-4">{errorMsg}</p>}
                    </div>
                </div>
            </Container>
        </div>
    );
}

export default ChooseRole;
